export default __webpack_public_path__ + "static/media/icon-favourite-clicked.7568135b.svg";